import React from "react";
import "./App.css";
import Weather from "./Weather";
export default function App() {
  return (
    <div className="App">
      <div className="container">
        <h1 className="title text-center"> Weather app</h1>
        <Weather defaultCity="Berlin" />
        <footer className="Footer">
          This project was coded by Ludania David and is open-sourced on{" "}
          <a
            href="https://github.com/Ludania-prog/w5-react-weater-app"
            target="blank"
          >
            Github
          </a>{" "}
          and hosted on <a href="https://www.netlify.com/">Netlify</a>.
        </footer>
      </div>
    </div>
  );
}
